<template>
  <div>
    <h1>Folders</h1>
    <p>
      <v-btn :to="{ name: 'folderEdit' }">
        <span>Create new&#160;</span>
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </p>
    <v-data-table
      :headers="headers"
      :items="folders"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      v-if="folders"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{ name: 'folder', params: { id: props.item.id } }"
              >{{ props.item.id }}</router-link
            >
          </td>
          <td>{{ props.item.name }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FOLDERS from "@/graphql/message/Folders";
export default {
  name: "Folders",
  metaInfo() {
    return {
      title: "Folders",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    folders: {
      query: FOLDERS,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Folder id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: false,
        page: 1,
        rowsPerPage: -1
      }
    };
  }
};
</script>